import selectionDetail from '@/view/selection/detail'

const activityRouter = [
  {
    path: '/selection/:id.html',
    name: 'selection-detail',
    component: selectionDetail,
    meta: {
      title: '精选合集详情页'
    }
  }
]

export default activityRouter



// WEBPACK FOOTER //
// ./src/router/selection/selection.js